// plan-06 S01: auto-generated from vpk.txt — do not edit
// regenerate with: tsx scripts/build-directory.ts

export interface DirectoryNode {
  id: number
  label: string
  url: string
  kind: 'ca' | 'external' | 'self' | 'portal'
}

export const DIRECTORY: DirectoryNode[] = [
  {
    "id": 1,
    "label": "dexscreener",
    "url": "https://dexscreener.com/solana/7ug4asstj14sfdbtd48zyl5r1hkzgvscwdhyxrn28fld",
    "kind": "external"
  },
  {
    "id": 2,
    "label": "token name",
    "url": "the vaguepost king",
    "kind": "external"
  },
  {
    "id": 3,
    "label": "ticker",
    "url": "$KING",
    "kind": "external"
  },
  {
    "id": 4,
    "label": "CA",
    "url": "4u1xmmG794nNLg3qCFb8ZSek9BAcoNua1ZYcskZrpump",
    "kind": "ca"
  },
  {
    "id": 5,
    "label": "solscan",
    "url": "https://solscan.io/token/4u1xmmG794nNLg3qCFb8ZSek9BAcoNua1ZYcskZrpump",
    "kind": "external"
  },
  {
    "id": 6,
    "label": "pump.fun page",
    "url": "https://pump.fun/coin/4u1xmmG794nNLg3qCFb8ZSek9BAcoNua1ZYcskZrpump",
    "kind": "external"
  },
  {
    "id": 7,
    "label": "website (main)",
    "url": "https://vaguepostking.com/",
    "kind": "self"
  },
  {
    "id": 8,
    "label": "website (\"vague souls\" game)",
    "url": "https://vaguesouls.xyz/",
    "kind": "portal"
  },
  {
    "id": 9,
    "label": "youtube",
    "url": "https://www.youtube.com/@vaguepostking",
    "kind": "external"
  },
  {
    "id": 10,
    "label": "twitter",
    "url": "https://x.com/vaguepostking",
    "kind": "external"
  },
  {
    "id": 11,
    "label": "twitter community",
    "url": "https://x.com/i/communities/2031714029857558653",
    "kind": "external"
  },
  {
    "id": 12,
    "label": "telegram",
    "url": "https://t.me/vaguepostkingdom",
    "kind": "external"
  },
  {
    "id": 13,
    "label": "tiktok",
    "url": "https://www.tiktok.com/@vaguepostking",
    "kind": "external"
  },
  {
    "id": 14,
    "label": "reddit",
    "url": "https://www.reddit.com/user/vaguepostking/",
    "kind": "external"
  },
  {
    "id": 15,
    "label": "github",
    "url": "https://github.com/vaguepostking",
    "kind": "external"
  },
  {
    "id": 16,
    "label": "instagram",
    "url": "https://www.instagram.com/vaguepostking48",
    "kind": "external"
  },
  {
    "id": 17,
    "label": "memedepot",
    "url": "https://memedepot.com/d/vaguepostkingdom",
    "kind": "external"
  },
  {
    "id": 18,
    "label": "soundcloud",
    "url": "https://on.soundcloud.com/WYTavWiRwt0vycXnmF",
    "kind": "external"
  },
  {
    "id": 19,
    "label": "probably (presave)",
    "url": "https://distrokid.com/hyperfollow/vaguepostking/probably",
    "kind": "external"
  },
  {
    "id": 20,
    "label": "substack",
    "url": "https://vaguepostking.substack.com/",
    "kind": "external"
  },
  {
    "id": 21,
    "label": "probable kings (mint)",
    "url": "https://www.launchmynft.io/mint/vaguepostking",
    "kind": "external"
  }
]
